import { Component } from "@angular/core";
import { Subscription } from "rxjs";

@Component({
    selector: "app-event-online",
    templateUrl: "./event-online.component.html",
    styleUrls: ["./event-online.component.scss"]
})
export class EventOnlineComponent {
    private eventsSubscription: Subscription;

    get icon(): string {
        return new Date().getSeconds() % 2 == 0 ? "radio_button_unchecked" : "fiber_manual_record";
    }

    constructor() {}
}
